import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close--sprite",
  "use": "close--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"close--sprite\">\n    <path d=\"M16.1 13.3L2.8 0 .3 2.5l13 13.6L0 29.5 2.5 32l13.6-13.6 13 13.6 2.6-2.5L18.4 16 32 2.5 29.5 0z\" fill=\"currentColor\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol